import { IMAGES } from "@/data/content";
import OrnamentalDivider from "@/components/OrnamentalDivider";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-20 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <img src={IMAGES.martin} alt="Martin, your storyteller guide"
               className="rounded-2xl w-full h-[560px] object-cover object-top" data-testid="martin-portrait" />
        </div>
        <div className="lg:col-span-7">
          <div className="stamp">About Martin</div>
          <h1 className="serif text-5xl md:text-6xl text-[#6E2638] mt-4 leading-tight">
            Still in the classroom after 15+ years — Melbourne is just the newest one.
          </h1>
          <OrnamentalDivider />
          <div className="space-y-4 text-[#1A1817]/85 leading-relaxed">
            <p>
              Martin has been walking curious visitors through Melbourne's CBD since 2026 —
              and he's still teaching, with over fifteen years across Victoria's classrooms
              behind him. He leans into the city's odd detail: the ghosts of the Coles book
              arcade, the misplaced ambition of the Rialto, the union hall on Bourke Street
              that changed a nation's mind.
            </p>
            <p>
              He runs one tour, personally. No script, no headsets, no shouting to be
              heard over a bus. Just walking pace, good stories, and a habit of stopping
              in front of things you've walked past a hundred times.
            </p>
            <p>
              Off the clock — when he isn't at the archives or the MCG — you'll find him
              arguing amiably about which tram route is the most beautiful (it's the 96).
            </p>
          </div>
          <div className="mt-8 flex gap-4 flex-wrap">
            <Link to="/individual" className="btn-primary" data-testid="about-book-btn">Walk with Martin</Link>
            <Link to="/contact" className="btn-outline-gold" data-testid="about-contact-btn">Say hello</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
